import React, { useEffect, useState } from "react";
import "../SellerConfirmedOrdersDetails/SellerConfirmedOrdersDetails.css";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import emptyorders from "../../assets/empty-cart.png";
import { Modal, Button } from "react-bootstrap";

export default function SellerNewordersDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
const [showModal, setShowModal] = useState(false);
const [showSuccess, setShowSuccess] = useState(false);

const token = localStorage.getItem("token");

const orderInfo = order?.order;
const userInfo = order?.user;
const items = order?.items || [];

  /* ================= FETCH ================= */
  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const res = await axios.get(
          `${BaseUrl}saller/order-details/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        setOrder(res.data?.data || null);
      } catch (err) {
        console.log(err);
        setOrder(null);
      } finally {
        setLoading(false);
      }
    };

    if (id && token) fetchOrder();
  }, [id, token]);

  /* ================= LOADING ================= */
  if (loading) {
    return (
      <div className="orders-loader text-center py-5 mt-5">
        <div className="loader-circle mb-3"></div>
        <p className="fw-bold">جاري تحميل التفاصيل...</p>
      </div>
    );
  }

  /* ================= EMPTY ================= */
  if (!order) {
    return (
      <div className="noorders text-center mt-5">
        <img src={emptyorders} alt="no-data" />
        <h4 className="mt-4">لا توجد بيانات لهذا الطلب</h4>

        <button
          className="order-btn mt-3"
          onClick={() => navigate("/seller/sellerneworders")}
        >
          الرجوع للطلبات
        </button>
      </div>
    );
  }

  return (
    <div
      className="container order-page pt-5"
      style={{ marginTop: "6%", marginBottom: "22%" }}
    >
      {/* USER */}
      <div className="card-box mb-4 user-card">
        <div className="avatar-circle mb-3" style={{    position: "relative",
    width: "96px",
    height: "93px"}}>
          <i className="fa-solid fa-user m-auto"></i>
        </div>

        <div>
          <h5 className="fw-bold">{userInfo?.name}</h5>
          <p className="small-text">{userInfo?.phone}</p>
          <p className="small-text">{userInfo?.email}</p>

          <p className="small-text">{userInfo?.country}</p>
        </div>
      </div>

      {/* PRODUCTS */}
      <div className="coproduct-details">
        <h6 className="fw-bold mb-3">تفاصيل الطلب</h6>

    {items.map((item) => (
  <div className="card-box mb-3" key={item.item_id}>
    <div className="product-wrapper-new position-relative w-100">

      {/* lock */}
      <div className="side-lock-codetails">
        <i className="fa fa-lock colockicon"></i>
      </div>

      {/* content */}
      <div className="coproduct-info">

        <h6 className="fw-bold mb-1">
          {item.item_name}
        </h6>

        {/* <p className="small-text mb-2">
          {item.description}
        </p> */}
        <p className="small-text mb-2">
  {item.description?.slice(0, 130)}...
</p>

        <div className="discount-price-row">

          <div className="discount-row">
               <span className="qty-badge">
              x{item.quantity}
            </span>
            <span className="discount-text mx-2">
              خصم {item.discount}%
            </span>

         
          </div>

          <div className="price-text">
            {item.total} ر.س
          </div>

        </div>
      </div>
    </div>
  </div>
))}

        <hr className="codetails-line" />

        {/* SUMMARY */}
        <div className="card-box summary-card mt-3 mb-5">
          <div className="cosummary-row">
            <span>العدد :</span>
            <span>{orderInfo.count_items}</span>
          </div>

          <div className="cosummary-row">
            <span>السعر :</span>
            <span>{orderInfo.total} ر.س</span>
          </div>

          <div className="cosummary-row">
            <span>مصاريف الشحن :</span>
            <span>{orderInfo.fees} ر.س</span>
          </div>
          <div className="cosummary-row">
            <span>طريقة الدفع</span>
            <span>{orderInfo.payment_type} </span>
          </div>
          <div className="cosummary-row total-row">
            <span>الإجمالي</span>
            <span>{orderInfo.final_total} ر.س</span>
          </div>
     
        </div>

        {/* ACTION BUTTON */}
        <div className="order-status-card mt-3">
  <div className="status-row d-flex justify-content-between align-items-center">
    
    <span className="status-title">حالة الطلب</span>

    <span className="status-text" style={{ color: "#FF580E", fontWeight: "bold" }}>
      {orderInfo.status === "pending"
        ? "قيد الانتظار"
        : orderInfo.status === "processing"
        ? "جاري المعالجة"
        : orderInfo.status === "shipping"
        ? "تم الشحن"
        : orderInfo.status === "completed"
        ? "تم التسليم"
        : orderInfo.status}
    </span>

  </div>
</div>
        {/* <button className="shipment-btn">
          تأكيد الطلب
        </button> */}
<button
  className="shipment-btn"
  onClick={() => setShowModal(true)}
>
  تأكيد الطلب
</button>


      </div>
<Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  centered
>
  <Modal.Body className="text-center">

    <h5 className="fw-bold mb-2">تأكيد الطلب</h5>

    <p className="text-muted mb-4">
      هل أنت متأكد من تنفيذ هذه العملية؟
    </p>

    <div className="d-flex gap-2">

      <Button
        variant="light"
        className="w-50"
        onClick={() => setShowModal(false)}
      >
        لا
      </Button>

      <Button
        style={{ background: "#2f4a8a", border: "none" }}
        className="w-50"
    onClick={async () => {
  try {
    await axios.get(
      `${BaseUrl}saller/order-accepted/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setShowModal(false);
    setShowSuccess(true);

  } catch (err) {
    console.log(err);
  }
}}
      >
        نعم
      </Button>

    </div>

  </Modal.Body>
</Modal>
<Modal
  show={showSuccess}
  onHide={() => setShowSuccess(false)}
  centered
>
  <Modal.Body className="text-center">

    {/* ICON */}
    <div
      style={{
        width: "70px",
        height: "70px",
        background: "#2f4a8a",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 15px"
      }}
    >
      <i className="fa fa-check text-white fs-3"></i>
    </div>

    {/* TEXT */}
    <h5 className="mb-3">تم بنجاح</h5>

    {/* BUTTON */}
    <button
      className="btn w-100"
      style={{
        background: "#2f4a8a",
        color: "#fff",
        borderRadius: "10px"
      }}
      onClick={() => setShowSuccess(false)}
    >
      حسناً
    </button>

  </Modal.Body>
</Modal>
    </div>
  );
}